// import React, { Fragment } from "react";
// import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
// // import { textAlign } from '@mui/system';
// // import { Font } from '@react-pdf/renderer'
// // import ADDRES from '../Images/ADDRES.png'
// // import Agency_Name from '../Images/Agency_Name.png'
// // import Email from '../Images/Email.png'
// // import Phone from '../Images/Phone.png'
// // import POC from '../Images/POC.png'

// // import {
// //     blueGrey
// //   } from '@mui/material/colors'
// //   import {
// //     createTheme
// //   } from '@mui/material/styles';

// // const theme = createTheme({
// //     palette: {
// //         primary: {
// //             main: blueGrey[900],
// //         },
// //         secondary: {
// //             main: blueGrey[100],
// //         },
// //     },
// // });

// const styles = StyleSheet.create({
//   boldLabel: {
//     fontWeight: "bold",
//   },

//   label: {
//     width: 60,
//     fontSize: 9,
//   },
//   invoiceDate: {
//     fontSize: 9,
//     fontStyle: "bold",
//     textAlign: "right",
//   },
//   ATTNContainer: {
//     flexDirection: "row",
//     fontSize: 9,
//   },
//   AddressContainer: {
//     flexDirection: "row",
//     fontSize: 9,
//   },
//   Date_Inv_Con: {
//     flexDirection: "column",
//     borderColor: "black",
//     width: "20%",
//     borderColor: "black",
//     padding: "3px",
//     textAlign: "right",
//   },
//   Quote_label: {
//     width: 70,
//     fontSize: 9,
//     fontWeight: "bold",
//   },
//   headerRow: {
//     flexDirection: "row",
//     backgroundColor: "#ffffffff",
//     fontWeight: "bold",
//     color: "black",
//     fontSize: 9,
//     marginTop: "10px",
//   },
//   From_Header: {
//     fontSize: 9,
//     width: "35%",
//     padding: "3px",
//     textAlign: "left",
//     fontWeight: "bold",
//     borderRightWidth: 0,
//   },
//   Order_Info: {
//     fontSize: 9,
//     width: "35%",
//     padding: "3px",
//     textAlign: "left",
//     fontWeight: "bold",
//     borderRightWidth: 0,
//   },
//   Ship_To_Header: {
//     fontSize: 9,
//     width: "30%",
//     padding: "3px",
//     textAlign: "left",
//     fontWeight: "bold",
//     borderLeftWidth: 0,
//   },
//   Total_Con: {
//     flexDirection: "row",
//     // borderTopWidth:1,
//     // borderBottomWidth: 1,
//     borderLeftWidth: 0,
//     borderRightWidth: 0,
//     borderColor: "black",
//   },
//   FromHeaderContainer: {
//     justifyContent: "flex-start",
//     width: "35%",
//     borderColor: "black",
//     fontSize: 9,
//     borderRightWidth: 0,
//     padding: "3px",
//     borderBottomWidth: 0,
//   },
//   ToContainer: {
//     // justifyContent: "flex-start",
//     width: "35%",
//     borderColor: "black",
//     fontSize: 9,
//     borderLeftWidth: 0,
//     padding: "3px",
//     borderBottomWidth: 0,
//   },
//   FromLabels: {
//     width: "70px",
//     fontSize: 9,
//     fontWeight: "bold",
//   },
//   FromLabelsFlow: {
//     flexDirection: "column",
//   },
//   Gap1: {
//     borderTopWidth: 0,
//     borderBottomWidth: 0,
//     borderLeftWidth: 0,
//     borderRightWidth: 0,
//     width: "30%",
//     backgroundColor: "white",
//     color: "black",
//   },
//   Gap2: {
//     width: "30%",
//     backgroundColor: "white",
//     fontSize: 9,
//     padding: "3px",
//   },
//   PackingSlip: {
//     textAlign: "start",
//     fontSize: 12,
//     fontWeight: "bold",
//     color: "black",
//   },
//   Main_Con: {
//     backgroundColor: "#e6e6e6",
//     marginTop: "10px",
//     marginBottom: "10px",
//   },
// });

// const InvoiceNo = ({ invoice }) => (
//   <Fragment style={styles.Main_Con}>
//     <Text style={styles.PackingSlip}>PACKING SLIP</Text>
//     <View style={styles.headerRow}>
//       <Text style={styles.From_Header}>SHIP TO</Text>
//       <Text style={styles.Order_Info}>ORDER INFO</Text>
//       <Text style={styles.Ship_To_Header}>SHIPPING INFO</Text>
//     </View>

//     <View style={styles.Total_Con}>
//       <View style={styles.FromHeaderContainer}>
//         <View style={styles.FromLabelsFlow}>
//           <Text>{invoice?.to_address}</Text>
//         </View>
//       </View>
//       <View style={styles.Gap2}>
//         <View style={styles.FromLabelsFlow}>
//           <Text>Contract Number: {invoice?.contract_number}</Text>
//           <Text>Purchase Order: {invoice?.purchase_order}</Text>
//           <Text>Amendment: {invoice?.amendment}</Text>
//           <Text>Unique Identifier: {invoice?.invoice_number}</Text>
//         </View>
//       </View>
//       <View style={styles.ToContainer}>
//         <View style={styles.FromLabelsFlow}>
//           <Text>Ship Date: {invoice?.ship_date}</Text>
//           <Text>Carrier: {invoice?.carrier}</Text>
//           <Text>Tracking #: {invoice?.tracking_number}</Text>
//         </View>
//       </View>
//     </View>
//   </Fragment>
// );

// export default InvoiceNo;

import React, { Fragment } from "react";
import moment from "moment";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  boldLabel: {
    fontWeight: "bold",
  },
  label: {
    width: 60,
    fontSize: 9,
  },
  invoiceDate: {
    fontSize: 9,
    fontStyle: "bold",
    textAlign: "right",
  },
  ATTNContainer: {
    flexDirection: "row",
    fontSize: 9,
  },
  AddressContainer: {
    flexDirection: "row",
    fontSize: 9,
  },
  Date_Inv_Con: {
    flexDirection: "column",
    borderColor: "black",
    width: "20%",
    borderColor: "black",
    padding: "3px",
    textAlign: "right",
  },
  Quote_label: {
    width: 70,
    fontSize: 9,
    fontWeight: "bold",
  },
  headerRow: {
    flexDirection: "row",
    backgroundColor: "#f2f2f2", // Adjusted the background color to match the second image
    fontWeight: "bold",
    color: "black",
    fontSize: 9,
    marginTop: "5",
  },
  From_Header: {
    fontSize: 9,
    width: "33%", // Adjusted width for equal distribution
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    borderRightWidth: 0,
    marginTop: "5",
    backgroundColor: "#f2f2f2", // Background color to match the second image
  },
  Order_Info: {
    fontSize: 9,
    width: "33%", // Adjusted width for equal distribution
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    borderRightWidth: 0,
    marginTop: "5",
    backgroundColor: "#f2f2f2", // Background color to match the second image
  },
  Ship_To_Header: {
    fontSize: 9,
    width: "34%", // Adjusted width for equal distribution
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    borderLeftWidth: 0,
    marginTop: "5",
    backgroundColor: "#f2f2f2", // Background color to match the second image
  },
  Total_Con: {
    flexDirection: "row",
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderColor: "black",
    backgroundColor: "#f2f2f2",
  },
  FromHeaderContainer: {
    justifyContent: "flex-start",
    width: "33%", // Adjusted width for equal distribution
    borderColor: "black",
    fontSize: 9,
    borderRightWidth: 0,
    padding: "3px",
    borderBottomWidth: 0,
    backgroundColor: "#f2f2f2",
  },
  ToContainer: {
    width: "33%", // Adjusted width for equal distribution
    borderColor: "black",
    fontSize: 9,
    borderLeftWidth: 0,
    padding: "3px",
    borderBottomWidth: 0,
  },
  FromLabels: {
    width: "70px",
    fontSize: 9,
    fontWeight: "bold",
  },
  FromLabelsFlow: {
    flexDirection: "column",
    backgroundColor: "#f2f2f2",
  },
  Gap1: {
    width: "33%", // Adjusted width for equal distribution
    backgroundColor: "white",
    color: "black",
  },
  Gap2: {
    width: "33%", // Adjusted width for equal distribution
    backgroundColor: "#f2f2f2",
    fontSize: 9,
    padding: "3px",
  },
  PackingSlip: {
    textAlign: "start",
    fontSize: 12,
    fontWeight: "bold",
    color: "black",
  },
  Main_Con: {
    backgroundColor: "#e6e6e6",
    marginTop: "10px",
    marginBottom: "10px",
  },
});

const InvoiceNo = ({ invoice }) => (
  <Fragment style={styles.Main_Con}>
    <Text style={styles.PackingSlip}>PACKING SLIP</Text>
    <View style={styles.headerRow}>
      <Text style={styles.From_Header}>SHIP TO</Text>
      <Text style={styles.Order_Info}>ORDER INFO</Text>
      <Text style={styles.Ship_To_Header}>SHIPPING INFO</Text>
    </View>

    <View style={styles.Total_Con}>
      <View style={styles.FromHeaderContainer}>
        <View style={styles.FromLabelsFlow}>
          <Text>{invoice?.to_address}</Text>
        </View>
      </View>
      <View style={styles.Gap2}>
        <View style={styles.FromLabelsFlow}>
          {invoice?.contract_number?.trim() && (
            <Text>Contract Number: {invoice.contract_number}</Text>
          )}
          {invoice?.purchase_order?.trim() && (
            <Text>Purchase Order: {invoice.purchase_order}</Text>
          )}
          {invoice?.delivery_order?.trim() && (
            <Text>Delivery Order: {invoice.delivery_order}</Text>
          )}
          {invoice?.amendment?.trim() && (
            <Text>Amendment: {invoice.amendment}</Text>
          )}
          {invoice?.invoice_number?.trim() && (
            <Text>Unique Identifier: {invoice.invoice_number}</Text>
          )}
        </View>
      </View>

      <View style={styles.ToContainer}>
        <View style={styles.FromLabelsFlow}>
          {invoice?.ship_date && (
            <Text style={styles.Label}>
              Ship Date: {moment(invoice.ship_date).format("MM/DD/YYYY")}
            </Text>
          )}
          {invoice?.carrier?.trim() && <Text>Carrier: {invoice.carrier}</Text>}
          {invoice?.tracking_number?.trim() && (
            <Text>Tracking #: {invoice.tracking_number}</Text>
          )}
        </View>
      </View>
    </View>
  </Fragment>
);

export default InvoiceNo;
